const STORAGE_PREFIX = 'gyl_quotation_draft_v4'
const LEGACY_PREFIXES = ['gyl_quotation_draft_v1', 'gyl_quotation_draft_v2', 'gyl_quotation_draft_v3']

function draftKey(categoryId) {
	return `${STORAGE_PREFIX}_${categoryId}`
}

export function loadQuotationDraft(categoryId) {
	if (!categoryId) return null
	try {
		const raw = localStorage.getItem(draftKey(categoryId))
		if (!raw) return null
		const data = JSON.parse(raw)
		if (!data || typeof data !== 'object' || !data.quotationForm) return null
		if (data.version !== 4) return null
		if (!data.quotationForm.draft_key) return null
		return data
	} catch (e) {
		console.warn('loadQuotationDraft failed', e)
		return null
	}
}

export function saveQuotationDraft(categoryId, payload) {
	if (!categoryId || !payload) return
	try {
		localStorage.setItem(draftKey(categoryId), JSON.stringify({
			version: 4,
			savedAt: Date.now(),
			...payload
		}))
	} catch (e) {
		console.warn('saveQuotationDraft failed', e)
	}
}

export function clearQuotationDraft(categoryId) {
	if (!categoryId) return
	localStorage.removeItem(draftKey(categoryId))
	LEGACY_PREFIXES.forEach(function(prefix) {
		localStorage.removeItem(`${prefix}_${categoryId}`)
	})
}

export function createQuotationDraftKey(prefix, userId) {
	const uid = userId || '0'
	const rand = Math.random().toString(36).slice(2, 10)
	return `${prefix}_${uid}_${Date.now()}_${rand}`
}
